import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Box } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var UserDataStepLayoutContainer = function UserDataStepLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Box, _extends({
    className: "user-data",
    mt: 8
  }, props), children);
};
UserDataStepLayoutContainer.propTypes = {
  children: PropTypes.node
};
UserDataStepLayoutContainer.defaultProps = {
  children: null
};
export { UserDataStepLayoutContainer as default };